<goa-card alignItemsH="space-between" alignItemsV="center" cardSize="full">
  <goa-card-header>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div>{{ headerText }}</div>
      <div *ngIf="canViewAction">
        <button mat-stroked-button color="primary" (click)="onViewAction()">
          View action
        </button>
      </div>
    </div>
  </goa-card-header>
  <goa-card-content>
    <p>
      {{ descriptionText }}
    </p>
    <jsg-multi-row-panel [showSeparator]="true">
      <jsg-single-row-panel first>
        <div first>
          <div>Style of cause</div>
          <div [innerHTML]="styleOfCause | safeHtml | incomplete"></div>
        </div>
      </jsg-single-row-panel>
      <jsg-single-row-panel second>
        <div first>
          <div>Judicial center</div>
          <div>{{ judicialCenter }}</div>
        </div>
        <div second>
          <div>Area of law</div>
          <div>{{ areaOfLaw }}</div>
        </div>
      </jsg-single-row-panel>
    </jsg-multi-row-panel>
  </goa-card-content>
</goa-card>
